module.exports = __webpack_public_path__ + "static/challenge-e429e9a2ba6534d80c9528b348c42adc.png";